import {ExperimentsBag} from '@wix/wix-experiments';

export const isExperimentEnabled = (experiments: ExperimentsBag = {}, experimentKey: string): boolean => {
  return experiments[experimentKey] === 'true';
};
